import { render } from "./status-bar-helper-cores-floating.vue?vue&type=template&id=0fd1db15&scoped=true"
import script from "./status-bar-helper-cores-floating.vue?vue&type=script&lang=js"
export * from "./status-bar-helper-cores-floating.vue?vue&type=script&lang=js"

import "./status-bar-helper-cores-floating.vue?vue&type=style&index=0&id=0fd1db15&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd1db15"]])

export default __exports__
import QResizeObserver from 'quasar/src/components/resize-observer/QResizeObserver.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QResizeObserver,QTooltip});
